import React from 'react';
import { Card, CardContent, CardMedia, Typography, Grid, Box,useTheme, useMediaQuery } from '@mui/material';
import MildSteelPlates from "../components/images/MildSteel.png"
import CobblePlateLowCarbon from "../components/images/CobblePlate.png"
import SquareSteelBillet from "../components/images/SquareSteel.png"
import LowCarbonWireRoad from "../components/images/Alloy.jpg"
import RoundSteelBillet from "../components/images/RoundSteel.png"
import { GradientContainer } from '../pages/AllProducts';
import Motor from "../components/AllProductsImages/Scrap Motor.jpg";
import Compressor from "../components/AllProductsImages/Scrap Compressor.jpg";
import Shredded from "../components/AllProductsImages/Scrap Shredded Steel Scrap.jpg"
// Data for products (you can replace this with props or data fetched from an API)
const products = [
    {
        title: 'MOTOR',
        image: Motor, 
        length: '255.44 mm',
        width: '255.44 mm',
        weight: '255.44 mm',
        thickness: '255.44 mm',
      },
      {
        title: 'COMPRESSOR',
        image: Compressor,
        length: '255.44 mm',
        width: '255.44 mm',
        weight: '255.44 mm',
        thickness: '255.44 mm',
      },
      {
        title: 'SHREDDED STEEL',
        image: Shredded,
        length: '255.44 mm',
        width: '255.44 mm',
        weight: '255.44 mm',
        thickness: '255.44 mm',
      },
      {
        title: 'ALLOY',
        image: LowCarbonWireRoad,
        length: '255.44 mm',
        width: '255.44 mm',
        weight: '255.44 mm',
        thickness: '255.44 mm',
      },
      // {
      //   title: 'ROUND STEEL BILLET',
      //   image: RoundSteelBillet,
      //   length: '255.44 mm',
      //   width: '255.44 mm',
      //   weight: '255.44 mm',
      //   thickness: '255.44 mm',
      // }
];

const ScrapProducts = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <GradientContainer>
    <Box sx={{ padding: 4, backgroundColor: '', display: 'flex', justifyContent: 'center' }}>
      <Grid container spacing={3} justifyContent="center">
        {products.map((product, index) => (
          <Grid 
            item xs={11} sm={6} md={3} key={index}
            sx={{ 
             
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Card sx={{ maxWidth: 345, borderRadius: '20px', overflow: 'hidden', margin: '0 auto' }}>
              <CardMedia
                component="img"
                height="200"
                image={product.image}
                alt={product.title}
              />
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  Length: {product.length} - Width: {product.width} - Weight: {product.weight} - Thickness: {product.thickness}
                </Typography>
                <Typography 
                  gutterBottom 
                  variant="h6" 
                  component="div" 
                  sx={{ 
                    marginTop: 2, 
                    fontFamily: 'Bebas Neue', 
                    fontSize: '33px', 
                    fontWeight: 400, 
                    textAlign: 'center', 
                    color: "#7371FC" 
                  }}
                >
                  {product.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  </GradientContainer>
  );
};

export default ScrapProducts;
